// extracted by mini-css-extract-plugin
module.exports = {"root":"RoadHazardOptionButton_root__2OBOy","title":"RoadHazardOptionButton_title__2Ehyv","icon":"RoadHazardOptionButton_icon__14o11"};